var _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _rect4, _rect5, _line11, _line12, _line13, _line14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolleyballCourt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1400 960",
    width: 1400,
    height: 960,
    style: {
      background: "white"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 10,
    width: 320,
    height: 45,
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 1280,
    height: 840,
    fill: "white",
    stroke: "black",
    strokeWidth: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 130,
    width: 1080,
    height: 700,
    fill: "white",
    stroke: "black",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 130,
    x2: 700,
    y2: 830,
    stroke: "black",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 538,
    y1: 130,
    x2: 538,
    y2: 830,
    stroke: "black",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 862,
    y1: 130,
    x2: 862,
    y2: 830,
    stroke: "black",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 60,
    x2: 160,
    y2: 130,
    stroke: "black",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 60,
    x2: 700,
    y2: 130,
    stroke: "black",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 60,
    x2: 1240,
    y2: 130,
    stroke: "black",
    strokeWidth: 3
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 830,
    x2: 160,
    y2: 900,
    stroke: "black",
    strokeWidth: 3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 830,
    x2: 700,
    y2: 900,
    stroke: "black",
    strokeWidth: 3
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 1240,
    y1: 830,
    x2: 1240,
    y2: 900,
    stroke: "black",
    strokeWidth: 3
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 100,
    x2: 700,
    y2: 860,
    stroke: "black",
    strokeWidth: 8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 694,
    y: 95,
    width: 12,
    height: 10,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 694,
    y: 855,
    width: 12,
    height: 10,
    fill: "black"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 538,
    y1: 830,
    x2: 538,
    y2: 860,
    stroke: "black",
    strokeWidth: 3,
    strokeDasharray: "8,6"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 538,
    y1: 100,
    x2: 538,
    y2: 130,
    stroke: "black",
    strokeWidth: 3,
    strokeDasharray: "8,6"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 862,
    y1: 830,
    x2: 862,
    y2: 860,
    stroke: "black",
    strokeWidth: 3,
    strokeDasharray: "8,6"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 862,
    y1: 100,
    x2: 862,
    y2: 130,
    stroke: "black",
    strokeWidth: 3,
    strokeDasharray: "8,6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolleyballCourt);
export default __webpack_public_path__ + "static/media/volleyball_court.9dee3fdcc15fe84f9eee57a8dfcb047e.svg";
export { ForwardRef as ReactComponent };